import { FunCode } from '@/constants/funcode'

/**
 * 请求配置项目
 */
export interface RequestConfig<T = unknown> {
    // requestId?: string; 或者 controller?: AbortController; // 待完善
    data?: T;
}

/**
 * Http 通用响应对象
 */
export interface CommonResult<T = unknown> {
    code: number;
    msg: string;
    total: number;
    data: T;
}

/**
 * Http 响应结果状态码
 */
export enum ResultCode {
    Success = 200, //成功
    Error = 101, //发生错误
    Fail = 102, //失败
    Warning = 103, //非法请求
    Unauthorized = 201, //授权失败
    ParameterError = 202, //参数错误
    InvalidToken = 20002, //令牌无效
    InvalidSign = 204, //签名无效
}

export interface SendMsgToMQ<T> {
    data?: T; // 请求参数
    requestCode: keyof typeof FunCode; // 请求功能码
    responseCode: keyof typeof FunCode; // 回复功能码
    marketId?: number;
}